import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import TrainingBanner from './TrainingBanner/TrainingBanner';

const Training = () => {
    return (
        <div>
            <Navigation></Navigation>
            <TrainingBanner></TrainingBanner>

        </div>
    );
};

export default Training;